import Modal from './Modal'
import React from 'react'

interface BoardsAttachedModalProps {
  list: auth.BoardsAttached
  onClose: base.BasicFunc
}

const BoardsAttachedModal: React.FC<BoardsAttachedModalProps> = ({ list, onClose }) => {
  return (
    <Modal
      onClose={onClose}
      title='Przypisane profile'
      secondaryButton='Rozumiem'
      secondaryButtonAction='close'>
      <div className='orderInfo__modal'>
        <div className='infobox'>
          Poniższe profile zostały przypisane do tego konta
        </div>
        {list.map(({ id, name }, index) => <div
          key={id}
          className='item'>
          <div className="standard">
            <p>{index + 1}. {name}</p>
          </div>
        </div>)}
      </div>
    </Modal>
  )
}

export default BoardsAttachedModal